import React from 'react';
import ReactDOM from 'react-dom/client';
import {init, miniApp, viewport, backButton, themeParams, retrieveLaunchParams} from '@tma.js/sdk-react';
import App from './App.jsx';
import './styles/index.css';

// Load Eruda debug console in debug mode
if (import.meta.env.VITE_DEBUG === 'true') {
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/eruda';
    script.onload = () => {
        window.eruda.init();
        console.log('🔧 Eruda loaded');
    };
    document.head.appendChild(script);
}

console.log('🚀 Starting TMA initialization...');

// Get launch params BEFORE init
const launchParams = retrieveLaunchParams();
console.log('📱 Platform:', launchParams.tgWebAppPlatform);

// Initialize Telegram Mini App SDK
init();

// Mount and configure Mini App components
if (miniApp.mount.isAvailable()) {
    miniApp.mount();
    miniApp.ready();
    miniApp.bindCssVars();

    // Check platform - only request fullscreen on mobile
    const platform = launchParams.tgWebAppPlatform;
    const isMobile = platform === 'android' || platform === 'ios' || platform === 'android_x';

    console.log('🔍 Platform:', platform, '| isMobile:', isMobile);

    // Request fullscreen mode only on mobile using Telegram WebApp API
    if (isMobile && window.Telegram?.WebApp) {
        try {
            const tgWebApp = window.Telegram.WebApp;

            // Check if requestFullscreen is available
            if (typeof tgWebApp.requestFullscreen === 'function') {
                tgWebApp.requestFullscreen();
                console.log('✅ Fullscreen requested via Telegram.WebApp');
            } else {
                console.log('ℹ️ requestFullscreen not available in this Telegram version');
            }

            // Disable vertical swipes to prevent closing
            if (typeof tgWebApp.disableVerticalSwipes === 'function') {
                tgWebApp.disableVerticalSwipes();
                console.log('✅ Vertical swipes disabled');
            }
        } catch (err) {
            console.error('❌ Telegram WebApp API error:', err);
        }
    } else {
        console.log('ℹ️ Skipping mobile features (desktop or WebApp not available)');
    }
}

// Configure viewport
if (viewport.mount.isAvailable()) {
    viewport.mount();
    viewport.expand();

    // Bind safe area insets to CSS variables
    if (viewport.bindSafeAreaInsetsCSSVars) {
        viewport.bindSafeAreaInsetsCSSVars();
    }

    // Bind content safe area insets to CSS variables
    if (viewport.bindContentSafeAreaInsetsCSSVars) {
        viewport.bindContentSafeAreaInsetsCSSVars();
    }
}

// Mount back button (will be shown/hidden by components)
if (backButton.mount.isAvailable()) {
    backButton.mount();
}

// Mount theme params
if (themeParams.mount.isAvailable()) {
    themeParams.mount();
    themeParams.bindCssVars();
}



ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>,
);
